<template>
  <div>
    <Navbar activeDirectory="gestione" activePage="admin-commessa"></Navbar>
    <div class="container-fluid py-4">
      
      <!-- Profile Header / Banner -->
      <div class="row">
        <div class="col-12">
          <div class="profile-header-banner p-4 text-white text-left mb-4 shadow-sm">
            <div class="d-flex align-items-center flex-wrap">
              <div class="profile-avatar mr-4 mb-2 mb-md-0 shadow-md">
                <i class="mdi mdi-briefcase text-primary"></i>
              </div>
              <div class="flex-grow-1">
                <h2 class="font-weight-bold text-white mb-1">{{ activeCommessa ? activeCommessa.nome : ('Commessa ' + lotto) }}</h2>
                <div class="d-flex align-items-center flex-wrap text-light small">
                  <span class="mr-3 mb-1"><i class="mdi mdi-tag-outline mr-1"></i>Codice: {{ activeCommessa && activeCommessa.codice_commessa ? activeCommessa.codice_commessa : 'N/D' }}</span>
                  <span class="mr-3 mb-1"><i class="mdi mdi-office-building-outline mr-1"></i>Stazione Appaltante: {{ activeCommessa && activeCommessa.stazione_appaltante ? activeCommessa.stazione_appaltante : 'N/D' }}</span>
                  <span class="mb-1"><i class="mdi mdi-calendar-range mr-1"></i>{{ activeCommessa ? formatDate(activeCommessa.data_inizio) + ' - ' + formatDate(activeCommessa.data_fine) : '' }}</span>
                </div>
              </div>
              
              <!-- Indicatore Commessa Attiva dal Contesto Globale -->
              <div class="mt-3 mt-md-0 select-commessa-profile text-left">
                <span class="badge badge-soft-light px-3 py-2 text-white" style="font-size:0.85rem; border: 1px solid rgba(255,255,255,0.2);">
                  <i class="mdi mdi-briefcase-outline mr-1" style="color: #F7931E;"></i>
                  {{ activeCommessa ? activeCommessa.nome : ('Commessa ' + lotto) }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Main Layout: Dettagli e Moduli -->
      <div class="row">
        <!-- Colonna Sinistra: Specifiche Tecniche / Dettagli -->
        <div class="col-12 col-lg-6 mb-4">
          <div class="au-card h-100 text-left">
            <div class="cw-section-title">
              <span class="cw-step-num"><i class="mdi mdi-information-variant"></i></span>Dettagli Commessa
            </div>
            
            <div class="detail-grid mt-4">
              <div class="detail-item-box p-3 mb-3 rounded-lg border bg-light-soft">
                <div class="d-flex align-items-center">
                  <div class="bg-soft-primary p-2 rounded-circle mr-3">
                    <i class="mdi mdi-tag text-primary h4 mb-0"></i>
                  </div>
                  <div>
                    <div class="detail-label">Codice Commessa</div>
                    <div class="detail-value font-weight-bold text-dark">{{ activeCommessa && activeCommessa.codice_commessa ? activeCommessa.codice_commessa : 'N/D' }}</div>
                  </div>
                </div>
              </div>
              
              <div class="row">
                <div class="col-md-6 mb-3">
                  <div class="detail-item-box p-3 rounded-lg border bg-light-soft h-100">
                    <div class="d-flex align-items-center">
                      <div class="bg-soft-warning p-2 rounded-circle mr-3">
                        <i class="mdi mdi-numeric-1-box-outline text-warning h4 mb-0"></i>
                      </div>
                      <div>
                        <div class="detail-label">Codice CIG</div>
                        <div class="detail-value font-weight-bold text-dark">{{ activeCommessa && activeCommessa.cig ? activeCommessa.cig : 'N/D' }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <div class="detail-item-box p-3 rounded-lg border bg-light-soft h-100">
                    <div class="d-flex align-items-center">
                      <div class="bg-soft-info p-2 rounded-circle mr-3">
                        <i class="mdi mdi-numeric-2-box-outline text-info h4 mb-0"></i>
                      </div>
                      <div>
                        <div class="detail-label">Codice CUP</div>
                        <div class="detail-value font-weight-bold text-dark">{{ activeCommessa && activeCommessa.cup ? activeCommessa.cup : 'N/D' }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="detail-item-box p-3 mb-3 rounded-lg border bg-light-soft">
                <div class="d-flex align-items-center">
                  <div class="bg-soft-success p-2 rounded-circle mr-3">
                    <i class="mdi mdi-currency-eur text-success h4 mb-0"></i>
                  </div>
                  <div>
                    <div class="detail-label">Importo Totale</div>
                    <div class="detail-value h4 mb-0 font-weight-bold text-success">{{ activeCommessa ? formatCurrency(activeCommessa.importo) : 'N/D' }}</div>
                  </div>
                </div>
              </div>

              <div class="detail-item-box p-3 mb-3 rounded-lg border bg-light-soft">
                <div class="d-flex align-items-center">
                  <div class="bg-soft-purple p-2 rounded-circle mr-3">
                    <i class="mdi mdi-office-building text-purple h4 mb-0"></i>
                  </div>
                  <div>
                    <div class="detail-label">Stazione Appaltante</div>
                    <div class="detail-value font-weight-bold text-dark">{{ activeCommessa && activeCommessa.stazione_appaltante ? activeCommessa.stazione_appaltante : 'N/D' }}</div>
                  </div>
                </div>
              </div>

              <div class="detail-item-box p-3 mb-3 rounded-lg border bg-light-soft">
                <div class="d-flex align-items-center">
                  <div class="bg-soft-danger p-2 rounded-circle mr-3">
                    <i class="mdi mdi-calendar-clock text-danger h4 mb-0"></i>
                  </div>
                  <div>
                    <div class="detail-label">Periodo di Esecuzione</div>
                    <div class="detail-value font-weight-bold text-dark">
                      {{ activeCommessa ? formatDate(activeCommessa.data_inizio) + ' — ' + formatDate(activeCommessa.data_fine) : 'N/D' }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="detail-item-box p-3 rounded-lg border bg-light-soft" v-if="activeCommessa && activeCommessa.descrizione">
                <div class="d-flex">
                  <div class="bg-soft-secondary p-2 rounded-circle mr-3 align-self-start">
                    <i class="mdi mdi-text-subject text-secondary h4 mb-0"></i>
                  </div>
                  <div>
                    <div class="detail-label">Descrizione</div>
                    <p class="detail-value text-muted italic mb-0">{{ activeCommessa.descrizione }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Colonna Destra: Moduli Abilitati -->
        <div class="col-12 col-lg-6 mb-4">
          <div class="au-card h-100 text-left">
            <div class="cw-section-title">
              <span class="cw-step-num"><i class="mdi mdi-layers"></i></span>Moduli Attivati
            </div>
            <p class="text-muted small mt-2">I moduli attivi abilitano specifiche funzionalità operative, statistiche e tipologie di intervento su questa commessa.</p>
            
            <div class="modules-grid mt-4">
              <div 
                v-for="mod in activeModules" 
                :key="mod.id" 
                class="module-card p-3 mb-3 rounded-lg border d-flex align-items-center justify-content-between premium-hover"
              >
                <div class="d-flex align-items-center">
                  <div class="module-icon-wrap p-3 rounded mr-3 bg-soft-primary">
                    <i :class="['ti-' + (mod.icona || 'layers'), 'h3 text-primary mb-0']"></i>
                  </div>
                  <div>
                    <h5 class="font-weight-bold mb-1 text-dark">{{ mod.nome }}</h5>
                    <span class="font-family-monospace text-muted small text-uppercase">{{ mod.codice }}</span>
                  </div>
                </div>
                <div>
                  <span class="badge badge-soft-success font-weight-bold px-3 py-1.5 rounded-pill"><i class="mdi mdi-check mr-1"></i>Attivo</span>
                </div>
              </div>
              
              <!-- Empty state moduli -->
              <div class="empty-state py-5 text-center" v-if="activeModules.length === 0">
                <i class="mdi mdi-layers-off-outline text-muted h1 d-block mb-3"></i>
                <h5 class="text-muted">Nessun Modulo Attivo</h5>
                <p class="text-muted small">Non sono stati ancora configurati moduli per questa commessa.</p>
              </div>

              <!-- Quick action to manage assets -->
              <div class="mt-4 pt-3 border-top text-right">
                <router-link
                  v-if="tipologia === 'D'"
                  :to="{ name: 'admin-assets', query: { action: 'add', fk_commessa: lotto } }"
                  class="btn btn-outline-success font-weight-bold px-4 py-2 shadow-sm rounded-pill"
                >
                  <i class="mdi mdi-plus-circle-outline mr-1"></i> Configura Nuovi Asset
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { Navbar } from "@/components";

import { contextStore } from "@/utils/contextStore";

export default {
  components: {
    Navbar
  },

  data() {
    return {
      tipologia: localStorage.getItem("tipologia"),
      activeModules: []
    };
  },

  computed: {
    contextStore() {
      return contextStore;
    },
    lotto() {
      return contextStore.activeCommessaId || "1";
    },
    commesse() {
      return contextStore.commesse;
    },
    activeCommessa() {
      return contextStore.activeCommessa;
    }
  },

  async mounted() {
    if (this.tipologia !== 'B' && this.tipologia !== 'D') {
      this.$router.push({ name: "home" });
      return;
    }

    await contextStore.fetchCommesse();
    await this.fetchMyModules();
  },

  watch: {
    'contextStore.activeCommessaId'() {
      this.fetchMyModules();
    }
  },

  methods: {
    fetchCommesse() {
      return contextStore.fetchCommesse();
    },

    fetchMyModules() {
      if (!this.lotto) return Promise.resolve();
      return this.axios.get(`/commesse/${this.lotto}/modules`).then(response => {
        this.activeModules = Array.isArray(response.data) ? response.data : [];
      }).catch(err => {
        console.error("Errore nel recupero moduli commessa:", err);
      });
    },

    formatCurrency(value) {
      if (!value) return "N/D";
      const num = parseFloat(value);
      if (isNaN(num)) return value;
      return new Intl.NumberFormat("it-IT", {
        style: "currency",
        currency: "EUR"
      }).format(num);
    },

    formatDate(dateStr) {
      if (!dateStr) return "N/D";
      try {
        const d = new Date(dateStr);
        if (isNaN(d.getTime())) return dateStr;
        return d.toLocaleDateString("it-IT");
      } catch (e) {
        return dateStr;
      }
    }
  }
};
</script>

<style scoped>
/* Page Layout Styles */
.profile-header-banner {
  background: linear-gradient(135deg, #F7931E, #F7931E);
  border-radius: 16px;
  position: relative;
  overflow: hidden;
}
.profile-header-banner::before {
  content: "";
  position: absolute;
  top: -50px;
  right: -50px;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
}
.profile-avatar {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.2rem;
}
.select-commessa-profile {
  background: rgba(255, 255, 255, 0.15);
  padding: 12px 18px;
  border-radius: 12px;
  backdrop-filter: blur(10px);
}
.profile-select {
  height: 38px !important;
  font-size: 0.85rem !important;
  padding-left: 36px !important;
  color: #1e293b !important;
  background-color: #ffffff !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
}

/* Card layout specifics */
.bg-light-soft {
  background-color: #f8fafc;
}
.bg-soft-primary {
  background-color: rgba(247, 147, 30, 0.1);
}
.bg-soft-warning {
  background-color: rgba(245, 158, 11, 0.1);
}
.bg-soft-info {
  background-color: rgba(6, 182, 212, 0.1);
}
.bg-soft-success {
  background-color: rgba(16, 185, 129, 0.1);
}
.bg-soft-danger {
  background-color: rgba(239, 68, 68, 0.1);
}
.bg-soft-purple {
  background-color: rgba(147, 51, 234, 0.1);
}
.text-purple {
  color: #9333ea;
}
.bg-soft-secondary {
  background-color: rgba(108, 117, 125, 0.1);
}
.module-icon-wrap {
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.premium-hover {
  transition: all 0.2s ease-in-out;
}
.premium-hover:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border-color: #F7931E !important;
}

/* Reusing design system properties */
.cw-section-title {
  font-size: 0.85rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.08em;
  color: #64748b; margin-bottom: 22px;
  display: flex; align-items: center;
}
.cw-step-num {
  width: 22px; height: 22px; border-radius: 50%;
  background: linear-gradient(135deg, #F7931E, #F7931E);
  color: #fff; font-size: 0.8rem; font-weight: 800;
  display: inline-flex; align-items: center; justify-content: center;
  margin-right: 10px; flex-shrink: 0;
}
.cw-label {
  font-size: 0.65rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.07em;
  color: #94a3b8; margin-bottom: 4px; display: block;
}
.detail-label {
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #94a3b8;
  margin-bottom: 2px;
}
.detail-value {
  font-size: 0.92rem;
  color: #1e293b;
}
.cw-select-wrap { position: relative; display: flex; align-items: center; }
.cw-select {
  width: 100%; height: 46px; padding: 0 38px 0 36px;
  border: 1.5px solid #e2e8f0; border-radius: 10px;
  background: #f8fafc; appearance: none; -webkit-appearance: none;
  font-size: 0.92rem; font-weight: 500; color: #1e293b;
  cursor: pointer; transition: border-color 0.2s, box-shadow 0.2s; outline: none;
}
.cw-field-icon {
  position: absolute; left: 12px;
  color: #94a3b8; font-size: 1rem; z-index: 2; pointer-events: none;
}
.cw-select-arrow {
  position: absolute; right: 14px;
  color: #94a3b8; font-size: 1rem; pointer-events: none;
}
.au-card {
  background: #fff; border-radius: 16px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.07);
  padding: 28px; border: 1px solid rgba(0,0,0,0.05);
}
.badge-soft-success {
  background-color: rgba(16, 185, 129, 0.1) !important;
  color: #10b981 !important;
  border: 1px solid rgba(16, 185, 129, 0.2) !important;
}
.badge-soft-primary {
  background-color: rgba(79, 70, 229, 0.1) !important;
  color: #F7931E !important;
  border: 1px solid rgba(79, 70, 229, 0.2) !important;
}
.rounded-lg {
  border-radius: 12px;
}
.shadow-md {
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}
</style>
